(() => {
  /* Sticky buy bar: shown once the first section has scrolled away, hidden while any shop section or
     the footer is on screen (there is a buy button there already). Visibility comes from
     IntersectionObservers only, so nothing runs on scroll. */
  const bar = document.querySelector('[data-glow-buybar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  const button = bar.querySelector('button');

  const first = document.querySelector('#MainContent > .shopify-section');
  const blockers = [...document.querySelectorAll('.glow-catalog, .glow-guarantee, .section-footer, footer')];

  let pastHero = false;
  const blocking = new Set();
  const update = () => {
    const show = pastHero && blocking.size === 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    if (button) button.tabIndex = show ? 0 : -1;
  };

  if (first) {
    new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(first);
  }

  const blockerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => (entry.isIntersecting ? blocking.add(entry.target) : blocking.delete(entry.target)));
    update();
  });
  blockers.forEach((node) => blockerObserver.observe(node));
})();
